import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { BlogApiData } from "../index";

interface MainContentSectionProps {
  formData: BlogApiData;
  onSectionChange: (section: keyof BlogApiData["al_sections"], field: string, value: string) => void;
  quillModules: any;
  quillFormats: string[];
}

// Secondary content removed per new schema


const MainContentSection: React.FC<MainContentSectionProps> = ({
  formData,
  onSectionChange,
  quillModules,
  quillFormats,
}) => {
  // Secondary content type removed


  // Secondary content change handler removed

  return (
    <>
      {/* Primary Content - Blue background */}
      <div className="bg-blue-50 p-4 rounded-lg border space-y-4">
        <h4 className="text-md font-medium text-blue-800 mb-3">Primary Content</h4>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Primary Title
            </label>
            <input
              type="text"
              value={formData.al_sections.mainContentSection.title}
              onChange={(e) =>
                onSectionChange(
                  "mainContentSection",
                  "title",
                  e.target.value
                )
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="e.g., Tirana's Hidden Treasures"
            />
          </div>
          <div className="lg:col-span-1">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Primary Description
            </label>
            <ReactQuill
              theme="snow"
              value={formData.al_sections.mainContentSection.description}
              onChange={(value) =>
                onSectionChange("mainContentSection", "description", value)
              }
              modules={quillModules}
              formats={quillFormats}
              placeholder="e.g., Beyond the well-known landmarks, Tirana offers countless hidden gems waiting to be discovered"
            />
          </div>
        </div>
      </div>

      {/* Secondary content removed */}
    </>
  );
};

export default MainContentSection;
